module.exports = __webpack_public_path__ + "static/image-05-b@2x-b274ee2ad5eb2105aedeb17831583b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-05-b@2x.jpg
// module id = 441
// module chunks = 3627797113349 20562973939449 33019919093843